/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "PostAuthAPI",
            "endpoint": "https://omkkge8wrg.execute-api.us-west-2.amazonaws.com/dev",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:3c433c8f-9b94-44b5-83c0-bae84529e0f7",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_2axuLRtXr",
    "aws_user_pools_web_client_id": "35ofq2q9dma78bp1hmbr22ub57",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "dev.biomechnet.org-dev",
    "aws_content_delivery_bucket_region": "us-west-2",
    "aws_content_delivery_url": "http://dev.biomechnet.org-dev.s3-website-us-west-2.amazonaws.com",
    "aws_user_files_s3_bucket": "biomechanics-uploads161949-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
